export const PLACE_SUGGESTIONS_URL = '/v0/autocomplete';
export const GEOCODE_BY_PLACE_ID_URL = '/v0/geolocate';
